import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { Button } from '../ui/Button';
import { visionPillars } from '../../data/policies';
const [featured, ...rest] = visionPillars;
export function VisionSection() {
  const navigate = useNavigate();
  return <section aria-labelledby="vision-heading" className="bg-white py-16 sm:py-20 lg:py-28" data-id="element-432" data-mp="5cp42hptbspf">
      <div className="mx-auto max-w-content px-4 sm:px-6 lg:px-10" data-id="element-433" data-mp="a3xg7lij1s6a">
        <SectionHeading eyebrow="The vision" title="The Nigeria we can build" intro="Six national outcomes that every policy in this campaign is measured against." action={<Button variant="secondary" onClick={() => navigate('/vision')} data-id="element-435" data-mp="3ijqz270bzfqi">
              Read the full vision
            </Button>} data-id="element-434" data-mp="3shn6anq5dqjc" />

        <div className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-436" data-mp="3nhsfslaab2yt">
          <Reveal className="lg:col-span-2 lg:row-span-2" data-id="element-437" data-mp="2za5mpwbuklaf">
            <Link to="/vision" className="group relative flex h-full min-h-[340px] flex-col justify-end overflow-hidden rounded-media bg-ink p-7 focus-visible:outline-offset-4" data-id="element-438" data-mp="2zcrsbqf6gqq0">
              <img src={featured.image} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-45 transition-transform duration-300 ease-emphasis group-hover:scale-[1.02]" data-id="element-439" data-mp="34ab6kqbvl3hy" />
              <span aria-hidden className="absolute inset-0 bg-ink/55" data-id="element-440" data-mp="2bjjeo51uf10f" />
              <span className="relative" data-id="element-441" data-mp="2pe299ubjp086">
                <span className="mb-3 inline-block text-[12px] font-bold uppercase tracking-[0.14em] text-gold-300" data-id="element-442" data-mp="2kmara86gg2tn">
                  Outcome 01
                </span>
                <h3 className="font-display text-[26px] leading-tight text-white sm:text-[32px]" data-id="element-443" data-mp="1wudfgh309asj">
                  {featured.title}
                </h3>
                <p className="mt-3 max-w-lg text-[15px] leading-relaxed text-white/75" data-id="element-444" data-mp="3s0eel3is06a4">
                  {featured.description}
                </p>
                <span className="mt-5 inline-flex items-center gap-2 text-[14px] font-semibold text-white" data-id="element-445" data-mp="r8thgynzmpw">
                  Explore this outcome
                  <ArrowUpRightIcon aria-hidden className="h-4 w-4 transition-transform duration-200 ease-emphasis group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-446" data-mp="ajekand6jy3i" />
                </span>
              </span>
            </Link>
          </Reveal>

          {rest.map((pillar, index) => <Reveal key={pillar.title} delay={0.04 * (index + 1)} data-id="element-447" data-mp="3j1awo2vchwx7" data-mpi={index}>
              <Link to="/vision" className="group flex h-full items-start gap-4 rounded-card border border-sand-200 bg-sand-50 p-5 transition-[border-color,box-shadow,transform] duration-200 ease-emphasis hover:border-green-200 hover:shadow-card" data-id="element-448" data-mp="3nzm8gj57ahi2">
                <span className="h-16 w-16 shrink-0 overflow-hidden rounded-lg" data-id="element-449" data-mp="2npbeg9a8fv23">
                  <img src={pillar.image} alt="" loading="lazy" className="h-full w-full object-cover" data-id="element-450" data-mp="2irt2ea0x4zpv" />
                </span>
                <span className="flex-1" data-id="element-451" data-mp="290f6ec86ei1h">
                  <h3 className="font-display text-[19px] leading-snug text-ink" data-id="element-452" data-mp="241lv8qgd334h">
                    {pillar.title}
                  </h3>
                  <p className="mt-1.5 text-[14px] leading-relaxed text-slate-600" data-id="element-453" data-mp="1zzh4bzhasklj">
                    {pillar.description}
                  </p>
                </span>
                <ArrowUpRightIcon aria-hidden className="mt-1 h-4 w-4 shrink-0 text-green-600 transition-transform duration-200 ease-emphasis group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-454" data-mp="1q2m3vb1gsa4m" />
              </Link>
            </Reveal>)}
        </div>
      </div>
    </section>;
}